import React from 'react';

function Footer() {
  return (
    <footer className="footer ">
      <p className="footer__copyright ">© 2020 No madic </p>
    </footer>
  );
}

export default Footer;
